import styled from 'styled-components'
import Icon from '@hotmart/space-lib/dist/components/icon'

export const CustomIcon = styled(Icon)`
  width: 2.56rem;
  height: 2.56rem;
  color: var(--cyan-darker);
`

CustomIcon.displayName = 'CustomIcon'
